export type { TemplateFieldType as FieldType, TemplateBlockType as BlockType, TemplateBlock } from '@/types'

import type { TemplateFieldType } from '@/types'

export const FIELD_TYPE_LABELS: Record<TemplateFieldType, string> = {
	TEXT_AREA: 'Текстовая область',
	DATE_PICKER: 'Ввод и выбор даты',
	DATE_RANGE_PICKER: 'Ввод и выбор промежутка дат',
}

export const FIELD_TYPES: TemplateFieldType[] = ['TEXT_AREA', 'DATE_PICKER', 'DATE_RANGE_PICKER']
